// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"erp-chart-container","216":"vendors","978":"price-chart"}[chunkId] + "." + {"57":"8f0e5728370442631176","216":"04b6235a2f3bc6f30860","978":"83e58c1d9255ebc30c8b"}[chunkId] + ".js";
};